<template>
  <div class="panel-body">
    <div class="">
      <div class="">
        <fieldset class="border current-plan">
          <legend class="border">現在の最大商品登録可能数</legend>
          <dl class="row text-center">
            <br>
            <dd class="col-sm-6"><h3>{{maxListingAmount}}商品</h3></dd>
            <dd class="col-sm-6" style="margin-top: 8px;"><button class="btn btn-info w-120" @click.prevent="openInfoModal">詳細</button></dd>
          </dl>
        </fieldset>
      </div>
      <div class="mr-t-10">
        <fieldset class="border choose-plan">
          <legend class="border">商品数の追加</legend>
          <h4 class="plan-section-title"><b>追加する商品数を選択して下さい。</b></h4>
          <div class="plan-list">
            <div
              v-for="(plan, index) in planList"
              :key="index"
              class="plan-item"
              :class="{ 'checked': plan.checked, 'optimal': plan.optimal }"
              @click="handleSelectPlan(plan)"
            >
              <input type="checkbox" class="plan-checkbox" v-model="plan.checked">
              <div class="plan-name" v-html="plan.salMonPlanName"></div>
              <div class="plan-price" v-if="plan.salMonPlanAmount">¥{{ formatNumber(plan.salMonPlanAmount) }}（税込み）</div>
              <div class="plan-desc" v-html="plan.salMonPlanDescription"></div>
              <div class="plan-qty-wrapper">
                <input type="number" class="plan-qty-input" :disabled="!plan.checked" v-model="plan.quantity" @click.stop>
                <span v-if="plan.optimal" class="optimal-badge">おすすめ</span>
              </div>
            </div>
          </div>

          <div class="summary-section">
            <div class="summary-item">
              <span>合計追加出品数:</span>
              <span>{{ totalItemsAdded }}商品</span>
            </div>
            <div class="summary-total">
              <span>合計料金:</span>
              <span>¥{{ totalPrice }}（税込み）</span>
            </div>
          </div>

          <div class="row mr-t-30">
            <div class="col-sm-12">
              <p>※「クレジット決済」 ボタンを押すと、カード決済システム【Stripe】の決済画面へ移動します</p>
            </div>
          </div>

          <div class="update-btn">
            <button class="btn btn-info w-200" :disabled="disabledSubmit" @click.prevent="openModal">売上金から支払う</button>
            <button class="btn btn-info w-120" :disabled="disabledSubmit" @click="doCheckout">クレジット決済</button>
          </div>
        </fieldset>
      </div>
      <info-modal v-if="showModalInfo" @close="closeInfoModal" :data="infoList" :totalAmount="maxListingAmount"></info-modal>
      <modal-confirm v-if="showModalConfirm" @confirm="handleSubmit" @close="closeModal" :message="planUpdateMessage"></modal-confirm>
    </div>
  </div>
</template>

<script>
import PlanService from '@/services/planservice'
import ModalConfirm from '@/components/ModalConfirm'
import InfoModal from '@/components/ListingInfoModal'
import Util from '@/common/utility'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  props: {
    currentTab: {
      type: String,
      default: ''
    }
  },
  components: {
    ModalConfirm,
    InfoModal
  },
  data () {
    return {
      planList: [],
      currentPlan: null,
      error: null,
      loader: null,
      isPrepareData: true,
      showModalConfirm: false,
      showModalInfo: false,
      maxListingAmount: 0,
      infoList: []
    }
  },
  async created () {
    await this.getMyPlan()
    await this.getAllPlans()
  },
  computed: {
    disabledSubmit () {
      return this.totalItemsAdded <= 0
    },
    totalItemsAdded () {
      return this.planList.reduce((total, plan) => total + (plan.checked ? plan.salMonPlanUpperlimit * plan.quantity : 0), 0)
    },
    totalPrice () {
      const total = this.planList.reduce((total, plan) => total + (plan.checked ? plan.salMonPlanAmount * plan.quantity : 0), 0)
      return this.formatNumber(total)
    },
    planUpdateMessage () {
      return `
        <p>商品数追加に必要な金額：¥${this.totalPrice}(税込み) を売上からマイナスをいたします。</p>
        <p>追加後に商品数を元に戻すことはできません。</p>
      `
    }
  },
  methods: {
    async getAllPlans () {
      const self = this
      await PlanService.getAllPlans()
        .then(data => {
          self.planList = data.salmonPlan.avaiablePlans
        })
        .catch(err => {
          self.error = err
        })
        .finally(() => {
          self.isPrepareData = false
          if (this.$route.params.tab === 'service-info') {
            this.$events.fire('done')
          }
        })
    },
    async getMyPlan () {
      const self = this
      await PlanService.getMyPlan()
        .then(data => {
          self.maxListingAmount = data.maxListingAmount
          self.infoList = data.data
        })
        .catch(err => {
          self.error = err
        })
    },
    formatNumber (number) {
      return Util.formatMoney(number)
    },
    handleSelectPlan (plan) {
      plan.checked = !plan.checked
      plan.quantity = plan.checked ? (plan.quantity || 1) : 0
    },
    validateSelection () {
      const hasInvalid = this.planList.some(plan => plan.checked && (!plan.quantity || plan.quantity < 1))
      if (hasInvalid) {
        alert('数量は1以上を入力してください。')
        return false
      }
      return true
    },
    openModal () {
      if (!this.validateSelection()) return
      this.showModalConfirm = true
    },
    closeModal () {
      $('#confirm-alert').modal('hide')
      this.showModalConfirm = false
    },
    async handleSubmit () {
      this.closeModal()
      const selectedPlans = this.planList.filter(plan => plan.checked)

      let logParams = {
        name: eventCode.settings.service_info_tab.click_payment_from_revenue_button,
        properties: {
          itemQuantityAdded: selectedPlans.map(p => p.salMonPlanName).join(', ')
        }
      }
      EventService.postTrackLog(logParams)

      this.loader = this.$loading.show()

      await PlanService.updatePlanBySales({ plans: selectedPlans })
        .then(() => {
          this.planList = this.planList.map(plan => ({ ...plan, checked: false, quantity: 0 }))
          this.getMyPlan()
          this.$store.commit('toggleModal', {
            show: true,
            message: 'お支払いありがとうございます。<br/>商品数が追加されました。'
          })
        })
        .catch(err => {
          this.$store.commit('toggleModal', {
            show: true,
            message: err
          })
        })
        .finally(() => {
          this.loader && this.loader.hide()
        })
    },
    async doCheckout () {
      if (!this.validateSelection()) return

      const selectedPlans = this.planList.filter(plan => plan.checked).map(plan => ({
        sku: plan.salMonPlanScript,
        quantity: plan.quantity
      }))

      let logParams = {
        name: eventCode.settings.service_info_tab.click_payment_credit_button,
        properties: {
          itemQuantityAdded: selectedPlans.map(p => p.sku).join(', ')
        }
      }
      EventService.postTrackLog(logParams)

      this.loader = this.$loading.show()

      await PlanService.getCheckoutSessionMulti({ plans: selectedPlans, redirectPath: this.$route.path.replace(/^\//, '') })
        .then(response => {
          if (response && response.data) {
            location.href = response.data
          }
        })
        .catch(error => {
          this.$store.commit('toggleModal', {
            show: true,
            message: error
          })
        })
        .finally(() => {
          this.loader && this.loader.hide()
        })
    },
    openInfoModal () {
      this.showModalInfo = true
      let logParams = {
        name: eventCode.settings.service_info_tab.click_detail_button,
        properties: {}
      }
      EventService.postTrackLog(logParams)
    },
    closeInfoModal () {
      this.showModalInfo = false
    }
  },
  mounted () {
    if (this.currentTab && this.currentTab === 'service-info') {
      let logParams = {
        name: eventCode.settings.service_info_tab.show,
        properties: {}
      }
      EventService.postTrackLog(logParams)
    }
  },
  beforeDestroy () {
    this.loader && this.loader.hide()
  }
}
</script>

<style scoped>
.plan-section-title {
  font-size: 14px;
  margin-bottom: 15px;
  color: #444;
  border-left: 3px solid #3b98d4;
  padding-left: 10px;
}

.plan-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.plan-item {
  display: flex;
  align-items: center;
  padding: 15px;
  border: 1px solid #ddd;
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.2s;
  position: relative;
  background: #fff;
  gap: 12px;
}

.plan-item.checked {
  background: #eef7f2;
  border-color: #28a745;
}

.plan-item:hover {
  border-color: #3b98d4;
}

.optimal-badge {
  position: absolute;
  top: -10px;
  left: 15px;
  background: #28a745;
  color: #fff;
  font-size: 11px;
  padding: 2px 8px;
  border-radius: 10px;
  font-weight: bold;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.plan-checkbox {
  min-width: 20px;
  margin-top: unset;
}

.plan-name {
  width: 180px;
  font-weight: bold;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 5px;
}

.plan-price {
  width: 200px;
  color: #d9534f;
  font-weight: bold;
  text-align: right;
}

.plan-desc {
  flex: 1;
  font-size: 13px;
  color: #555;
}

.plan-qty-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 120px;
}

.plan-qty-input {
  width: 50px;
  padding: 5px;
  border: 1px solid #ddd;
  border-radius: 3px;
  text-align: center;
  font-size: 13px;
}

.plan-qty-input:disabled {
  background: #f5f5f5;
  color: #999;
}

.summary-section {
  margin-top: 20px;
  padding-top: 15px;
  border-top: 1px solid #ddd;
}

.summary-item {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
  font-size: 13px;
}

.summary-total {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  font-size: 16px;
  font-weight: bold;
  color: #d9534f;
}
</style>



// WEBPACK FOOTER //
// src/view/setting/ServiceInfo.vue